import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
} from "react-native";
import { useRecoilState } from "recoil";
import { tokenState } from "../reducer/recoil";
import { apiservice } from "../service";
import { useIsFocused } from "@react-navigation/native";
import { styles, stylesResponsive, styles1280 } from "./style/flatlistNews";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

const { width, height } = Dimensions.get("window");
export default function FlatListNews({ onPress, navigation, InfoGuestAdmin }) {
  const [state, setstate] = useState([]);
  const isfocused = useIsFocused();
  console.log("state>>>", state);
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setData] = useState([
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
    {
      title: "Asian  Athletics Championships",
      detail:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Nunc tincidunt justo sem, eu volutpat magna viverra at.Pellentesque dapibus vestibulum dapibus. Nullam quamvelit, suscipit non turpis vel, consectetur efficitur justo.",
    },
  ]);
  useEffect(() => {
    getAllcompe(token);
  }, [token, isfocused]);
  async function getAllcompe(token) {
    try {
      const response = await apiservice({
        path: "/competitions/",
        method: "get",
        // token: token,
      });
      setstate(response.data !== undefined && response.data.competitions);
    } catch (error) {
      throw error;
    }
  }
  return (
    <FlatList
      data={state}
      numColumns={width < 1280 ? 1 : 3}
      scrollEnabled={width < 1280 ? true : false}
      renderItem={({ index, item }) => {
        console.log(item);
        return (
          <TouchableOpacity
            onPress={() => {
              navigation.navigate("InfoGuestAdmin", item);
            }}
            style={width < 1280 ? stylesResponsive.button : styles.button}
          >
            <Image
              resizeMode={"contain"}
              style={
                (width < 1280 && stylesResponsive.img) ||
                (width < 1600 && styles1280.img) ||
                styles.img
              }
              source={{ uri: item.image_url }}
            />
            <Text
              numberOfLines={1}
              style={width < 1600 ? styles1280.textTitle : styles.textTitle}
            >
              {item.name}
            </Text>
            <Text
              numberOfLines={4}
              style={width < 1600 ? styles1280.textDetail : styles.textDetail}
            >
              {ReactHtmlParser(item.description)}
            </Text>
          </TouchableOpacity>
        );
      }}
    />
  );
}
